module.exports = __webpack_public_path__ + "static/media/listnews-icon.66ef0dc1.svg";